import React from 'react';

export const WaveAnimation = () => {
  return (
    <div className="wave-container">
      <svg viewBox="0 0 2400 120" preserveAspectRatio="none" style={{ width: '200%', height: '100%' }}>
        {/* Wave 1 - front */}
        <path
          className="wave-path"
          d="M0,60 C150,20 350,100 600,60 C850,20 1050,100 1200,60 C1350,20 1550,100 1800,60 C2050,20 2250,100 2400,60 L2400,120 L0,120 Z"
          fill="rgba(46,143,149,0.3)"
        />
        {/* Wave 2 - mid */}
        <path
          className="wave-path"
          d="M0,75 C200,45 400,105 600,75 C800,45 1000,105 1200,75 C1400,45 1600,105 1800,75 C2000,45 2200,105 2400,75 L2400,120 L0,120 Z"
          fill="rgba(46,143,149,0.2)"
          style={{ animationDelay: '-3s' }}
        />
        {/* Wave 3 - back */}
        <path
          className="wave-path"
          d="M0,85 C250,65 450,105 600,85 C750,65 950,105 1200,85 C1450,65 1650,105 1800,85 C1950,65 2150,105 2400,85 L2400,120 L0,120 Z"
          fill="rgba(183,137,47,0.08)"
          style={{ animationDelay: '-6s' }}
        />
      </svg>
    </div>
  );
};

export default WaveAnimation;
